import { isBefore } from 'date-fns'
import { CompanyUserData } from '~services/interfaces'
import { SortType } from '../interfaces'

const sort = {
  alphabetic: (users: CompanyUserData[]): CompanyUserData[] =>
    users.sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase() ? 1 : b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0
    ),
  older: (users: CompanyUserData[]): CompanyUserData[] =>
    users.sort((a, b) => (isBefore(new Date(a.createdAt), new Date(b.createdAt)) ? -1 : 1)),
  newer: (users: CompanyUserData[]): CompanyUserData[] =>
    users.sort((a, b) => (isBefore(new Date(a.createdAt), new Date(b.createdAt)) ? -1 : 1)).reverse(),
  latest_access: (users: CompanyUserData[]): CompanyUserData[] =>
    users.sort((a, b) => (isBefore(new Date(a.lastAccess), new Date(b.lastAccess)) ? -1 : 1)).reverse(),
}

export const sortEventType = {
  0: 'Ordem alfabética',
  1: 'Usuário mais antigo',
  2: 'Usuário mais recente',
  3: 'Último acesso',
}

export const filterEventTypePermissionId = {
  1: 'Administrador',
  2: 'Colaborador',
}

export const filterEventTypeNumber = {
  0: 'Telefone fixo',
  1: 'Celular',
  2: 'Whatsapp',
  3: 'Telefone empresarial',
}

export const filterEventSectorId = {
  1: 'Administrativo',
  2: 'Comercial',
  3: 'Compras',
  4: 'Diretoria',
  5: 'Financeiro',
  6: 'Fiscal',
  7: 'Gerencial',
  8: 'Operacional',
  9: 'Compras',
}

const sortType = {
  '0': sort.alphabetic,
  '1': sort.older,
  '2': sort.newer,
  '3': sort.latest_access,
  default: (users: CompanyUserData[]): CompanyUserData[] => users,
}

export function getListSort(users: CompanyUserData[], sort?: SortType): CompanyUserData[] {
  return !sort ? sortType.default(users) : sortType[sort](users)
}

export function copyUsersRef(users: CompanyUserData[]): CompanyUserData[] {
  return JSON.parse(JSON.stringify(users)) as CompanyUserData[]
}
